import createBaseService from "@/api/base-service.ts";
import type { Raffle } from "../../types/raffle";

const countryService = {
	...createBaseService<Raffle>("/countries"),
};

export default countryService;
